var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:_vm.iClass,style:(_vm.style),on:{"click":_vm.clicked}})
}
var staticRenderFns = []

export { render, staticRenderFns }